import React from 'react'

const content = {
  checkinfo: (
    <>
      La <b>disponibilité effective en Suisse</b> des fruits et légumes de cet
      aperçu est vérifiée <b>plusieurs fois par année.</b> Par exemple, lorsque
      le printemps est relativement froid, les asperges seront classées comme
      «actuellement disponibles» uniquement à la fin avril (et non pas plus tôt,
      comme c'est souvent le cas).
    </>
  ),
  text: (
    <>
      <p>
        Cuisiner en fonction des saisons, c'est faire mieux &mdash; à bien des
        égards: les avions sont ainsi moins chargés en ananas et avocats
        exotiques. Des milliers de kilomètres en camion (par exemple entre
        l'Espagne et la Suisse) peuvent être économisés. Il y a moins de serres
        à chauffer, ce qui consomme beaucoup d'énergie. On contribue également à
        réduire les emballages utilisés. Entre les concombres en provenance du
        Maroc, emballés individuellement, et ceux de l'agriculture locale,
        disposés simplement dans une caisse en bois et vendus directement dans
        l’exploitation, il n’y a pas photo.
      </p>
      <p>
        Manger des fruits et des légumes de saison est aussi une question de
        plaisir: la différence est immense entre les tomates fraîches du jardin,
        peut-être même encore chaudes du soleil, et celles qui sont importées au
        mois de février.
      </p>
      <p>
        Il se peut même que nous économisons de l'argent en achetant des
        produits régionaux: même si l'on prétend toujours que l'achat de
        produits locaux est plus cher – ce n'est pas totalement vrai. Car si
        j'achète des choux-raves ou de la laitue de saison au marché
        hebdomadaire, ils resteront frais et appétissants plus longtemps que
        d’autres légumes, qui ne sont pas de saison. Ainsi, la probabilité de
        devoir les jeter diminue, permettant aussi de réduire le gaspillage
        alimentaire.
      </p>
      <p>
        Et il ne faut pas oublier: c'est un vrai plaisir que de manger au fil
        des saisons. Quel délice de déguster les premières asperges avec une
        sauce hollandaise faite maison lorsqu’on a attendu jusqu'à la fin du
        mois d'avril pour trouver des fournisseurs régionaux! Comme les premiers
        abricots du Valais sont succulents lorsqu'ils ont été fraîchement
        récoltés! Il en va de même pour la soupe faite à partir des premières
        courges en automne. Ou pour la doucette cultivée en plein air à
        l'approche de l'hiver.
      </p>
      <p>
        Acheter de saison, c'est incontestablement faire mieux. Et c'est dans
        cet esprit que nous espérons avoir apporté notre contribution à une
        alimentation durable et à davantage de plaisir avec ce calendrier des
        fruits et légumes, constamment actualisé.
      </p>
    </>
  )
}

export default content
